import { RawTeam, Team } from './typings';

export const serializeTeamForFront = (data: RawTeam): Team => ({
  id: data.id,
  name: data.fields.Name,
  people: data.fields.People,
});
